/**
 * @mergeTarget
 * @module Src/Utils
 */
/**
 * Enumerator of all possible error codes
 * @source
 */
var LisioProfilErrorCodes;
(function (LisioProfilErrorCodes) {
    /**
     * If this error code was sent, you probably forgot or misspelled a profile name and his builder in {@link Src/Profiles.LisioProfileFactory._builders | LisioProfileFactory._builders} or in enum {@link Src/Profiles.LisioProfileNames | LisioProfileNames}.
     */
    LisioProfilErrorCodes["PROFILE_NOT_FOUND"] = "LisioProfil_0";
    /**
     * If this error code was sent, you probably forgot or misspelled a string parameter name or your value not corresponding to this parameter.
     */
    LisioProfilErrorCodes["WRONG_PARAMETER"] = "LisioProfil_1";
    /**
     * If this error code was sent, you probably forgot or misspelled a string parameter name in {@link Src/Parameters/String.LisioStringParameter | LisioStringParameter} or your value is not in option enum linkd for this parameter.
     */
    LisioProfilErrorCodes["WRONG_STRING_PARAMETER"] = "LisioProfil_2";
    /**
     * If this error code was sent, you probably forgot or misspelled a string parameter name in {@link Src/Parameters/Numeric.LisioNumericParameter | LisioNumericParameter} or your default value is not in {@link Src/Parameters/Numeric.defautValueOfNumericParameters | defautValueOfNumericParameters} for this parameter.
     */
    LisioProfilErrorCodes["WRONG_DEFAULT_VALUE_NUMERIC_PARAMETER"] = "LisioProfil_3";
    /**
     * If this error code was sent, you probably forgot or misspelled a category name and his builder in {@link Src/Categories.LisioCategoryFactory._builders | LisioCategoryFactory._builders} or in enum {@link Src/Categories.LisioCategoryNames | LisioCategoryNames}.
     */
    LisioProfilErrorCodes["CATEGORY_NOT_FOUND"] = "LisioProfil_4";
})(LisioProfilErrorCodes || (LisioProfilErrorCodes = {}));
export { LisioProfilErrorCodes };
